export const PLATFORM_PUBLIC_PATHS = ['/', '/login'];
